import type { Session } from "../shared/contracts.js";
let csrfToken = "";
export class ApiError extends Error {
  code: string;
  status: number;
  details: unknown;
  helpTopic?: string;
  constructor(status: number, body: any) {
    super(
      body?.error?.message || body?.message || `Request failed (${status})`,
    );
    this.name = "ApiError";
    this.status = status;
    this.code = body?.error?.code || "REQUEST_FAILED";
    this.details = body?.error?.details;
    this.helpTopic = body?.error?.helpTopic;
  }
}
export function setCsrfToken(value?: string) {
  csrfToken = value || "";
}
export function captureSession(session?: Session) {
  if (session?.csrfToken) csrfToken = session.csrfToken;
  return session;
}
export async function api<T = any>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const url = path.startsWith("/api/")
    ? path
    : `/api/v1${path.startsWith("/") ? "" : "/"}${path}`;
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof FormData))
    headers.set("Content-Type", "application/json");
  if (
    csrfToken &&
    !["GET", "HEAD"].includes((options.method || "GET").toUpperCase())
  )
    headers.set("X-CSRF-Token", csrfToken);
  const response = await fetch(url, {
    ...options,
    headers,
    credentials: "include",
  });
  const text = await response.text();
  let body: any;
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    body = {
      error: {
        message: text.slice(0, 300) || "Invalid server response",
        code: "INVALID_RESPONSE",
      },
    };
  }
  if (!response.ok) throw new ApiError(response.status, body);
  if (body?.session?.csrfToken) captureSession(body.session);
  if (body?.csrfToken) csrfToken = body.csrfToken;
  return body as T;
}
export function downloadText(
  name: string,
  content: string,
  type = "application/json",
) {
  downloadBlob(name, new Blob([content], { type }));
}
export function downloadBlob(name: string, blob: Blob) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
